import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import { Box } from '@chakra-ui/react';
import { sx } from '../data-driven/markdownStyle';
import { options } from './data';

export const Process = ({ service, stage, wakeProcess }) => {
	const [loading, setLoading] = useState(true);
	const [markdown, setMarkdown] = useState([]);

	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get(`/markdown/${service}`, options());
			if (!active) {
				return;
			}
			setMarkdown(res.data.markdown);
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [wakeProcess, service]);

	if (loading) return <p>Loading...</p>;
	const stages = markdown.reduce(
		(acc, { place, content }) => ({ ...acc, [place]: content }),
		{}
	);

	if (stage === false)
		return (
			<Box {...{ sx }}>
				<ReactMarkdown children={stages[`${service}:`]} />
			</Box>
		);

	const shown = [`${service}:1`, `${service}:2`].slice(0, +stage);

	return (
		<>
			{shown.map(key => (
				<Box {...{ key, sx }}>
					<ReactMarkdown children={stages[key]} />
				</Box>
			))}
		</>
	);
};
